module.exports = __webpack_public_path__ + "img/contact_mail.216219fe.svg";